"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ScriptHackComponent = /** @class */ (function () {
    function ScriptHackComponent() {
    }
    ScriptHackComponent.prototype.convertToScript = function () {
        var element = this.script.nativeElement;
        var script = document.createElement("script");
        script.type = this.type ? this.type : "text/javascript";
        if (this.src) {
            script.src = this.src;
        }
        if (element.innerHTML) {
            script.innerHTML = "(adsbyjuicy = window.adsbyjuicy || []).push({'adzone':" + element.innerHTML + "});";
        }
        var parent = element.parentElement;
        parent.parentElement.replaceChild(script, parent);
    };
    ScriptHackComponent.prototype.ngAfterViewInit = function () {
        this.convertToScript();
    };
    return ScriptHackComponent;
}());
exports.ScriptHackComponent = ScriptHackComponent;
